import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { PublicVideo } from '@core/models/entities/video.models';
import { VideoService } from '@core/services/api/video.service';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PublicVideoResolver {
  constructor(private videoService: VideoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<PublicVideo> {
    return this.videoService.getPublicVideo(route.params['id']);
  }
}
